import React, { useEffect } from "react";
import { motion } from "framer-motion";
import Me from "../../assets/me.png";

const Home = () => {
  useEffect(() => {
    document.title = "About Me — Viktoriia Yashkina";
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.75, ease: "easeOut" }}
      className="body"
    >
      <div className="containerBody">
        <div className="containerContext">
          <h2 className="h2">about me</h2>
          <div className="mb-5">
            <h3 className="h3">Background</h3>
            <div className="flex flex-col lg:flex-row lg:gap-x-[7rem]">
              <div className="textContainer">
                <p>
                  Born and raised in Ukraine. Sociology Bachelor. I am just a
                  human being. Nothing special, as you can see. However, I am
                  also a cheerful and hardworking dreamer.
                </p>
                <p>
                  My coding journey began in programming class during high
                  school. Thanks to Tumblr, I started genuinely to like coding.
                  I even wanted to go to university to study computer science in
                  2014. Unfortunately, I abandoned this decision due to many
                  beyond my control factors.
                </p>
                <p>
                  It took me nine years to back to my dream. Throughout this
                  time, I left one university after three years of study, earned
                  a Bachelor's degree in sociology at another university,
                  changed several jobs, and left my country because of war.
                </p>
                <p>
                  I am 26 years old, and I have a rather unpredictable life.
                  Some people would say that I am a total failure. It's a point
                  of view that I disagree with. Everyone deserves a chance to
                  change their life. And I'm working on it.
                </p>
              </div>

              <div className="flex justify-center items-center">
                <img src={Me} alt="Me" className="h-auto max-w-[200px]" />
              </div>
            </div>
          </div>

          <div className="mb-5">
            <h3 className="h3">My Resume</h3>
            <div className="flex flex-col">
              <div className="textContainer">Download</div>
            </div>
          </div>

          <div className="mb-5">
            <h3 className="h3">Skills</h3>
            <div className="flex flex-col lg:flex-row justify-between">
              <div className="lg:w-[45%]">
                <p className="font-accentFont text-[25px]">
                  HTML CSS Bootstrap Tailwind
                </p>
                <p className="font-accentFont text-[25px]">
                  JavaScript React JS API GIT
                </p>
                <p className="font-accentFont text-[25px]">
                  PostgreSQL MySQL Excel Photoshop
                </p>
              </div>
              <div className="lg:w-[45%]">
                <p className="font-accentFont text-[20px]">
                  Guide and Advise | Provided assistance to colleagues with
                  various work things.
                </p>
                <p className="font-accentFont text-[20px]">
                  Diligent and Zealous | To learn new things to improve the
                  quality of work.
                </p>
                <p className="font-accentFont text-[20px]">
                  Enthusiastic and Willing | To work with new people.
                </p>
                <p className="font-accentFont text-[20px]"></p>
              </div>
            </div>
          </div>

          <div className="mb-5">
            <h3 className="h3">Goals</h3>
            <div className="flex flex-col lg:flex-row justify-between">
              <div className="lg:w-[45%]">
                <p>
                  My main career goal is to one day to become a full-stack
                  developer.
                </p>
                <p>A good one, of course.</p>
                <p>
                  It is not important where I will start - as a front-end
                  developer or back-end.
                </p>
                <p>What's important is the result o(〃＾▽＾〃)o</p>
              </div>
              <div className="lg:w-[45%]">
                <p>
                  Alongside career goals, I also have ones for personal growth.
                </p>
                <p>First of all, I want to learn calligraphy.</p>
                <p>Then, I want to learn Korean and Japanese languages.</p>
                <p>The last goal is to get a degree in computer science.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default Home;
